<template>
  <div class="d-flex justify-content-between align-items-center">
    <!-- iOS Safari moves a tap on a small icon in a clickable table row to
         the cell; the padding, cancelled by equal negative margins, gives the
         tap somewhere to land without moving the icon. -->
    <button
      type="button"
      class="-m-3 p-3 link"
      aria-label="Edit note"
      @click="open || toggleModal()"
    >
      <i class="fas fa-edit" aria-hidden="true"></i>
    </button>
    <call-note-modal
      v-if="open"
      :call-id="callId"
      :note-text="noteText"
      :add-note-path="addNotePath"
      :remove-note-path="removeNotePath"
      @hide-modal="toggleModal"
    ></call-note-modal>
  </div>
</template>

<script>
import CallNoteModal from "./CallNoteModal.vue";
export default {
  components: {
    CallNoteModal,
  },
  props: {
    callId: {
      type: Number,
      default: null,
    },
    noteText: {
      type: String,
      default: null,
    },
    noteToolTip: {
      type: String,
      default: null,
    },
    addNotePath: {
      type: String,
      default: null,
    },
    removeNotePath: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggleModal() {
      this.open = !this.open;
    },
  },
};
</script>

<style lang="scss" scoped></style>
